;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .constant('csVulnerabilitiesDetectedConstants', {
      LAST: 'LAST',
      FIRST: 'FIRST'
    })
})()
